/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Per_Unit_HourInputs */

const en_admin_resource_form_per_unit_hour = /** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per hour`)
};

const de_admin_resource_form_per_unit_hour = /** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Stunde`)
};

const es_admin_resource_form_per_unit_hour = /** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por hora`)
};

const fr_admin_resource_form_per_unit_hour = /** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par heure`)
};

const nl_admin_resource_form_per_unit_hour = /** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per uur`)
};

/** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */
const it_admin_resource_form_per_unit_hour = en_admin_resource_form_per_unit_hour;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */
const pt_br2_admin_resource_form_per_unit_hour = en_admin_resource_form_per_unit_hour;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */
const pl_admin_resource_form_per_unit_hour = en_admin_resource_form_per_unit_hour;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */
const hu_admin_resource_form_per_unit_hour = en_admin_resource_form_per_unit_hour;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_HourInputs) => LocalizedString} */
const ro_admin_resource_form_per_unit_hour = en_admin_resource_form_per_unit_hour;

/**
* | output |
* | --- |
* | "per hour" |
*
* @param {Admin_Resource_Form_Per_Unit_HourInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_per_unit_hour = /** @type {((inputs?: Admin_Resource_Form_Per_Unit_HourInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Per_Unit_HourInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_per_unit_hour(inputs)
	if (locale === "de") return de_admin_resource_form_per_unit_hour(inputs)
	if (locale === "es") return es_admin_resource_form_per_unit_hour(inputs)
	if (locale === "fr") return fr_admin_resource_form_per_unit_hour(inputs)
	if (locale === "nl") return nl_admin_resource_form_per_unit_hour(inputs)
	if (locale === "it") return it_admin_resource_form_per_unit_hour(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_per_unit_hour(inputs)
	if (locale === "pl") return pl_admin_resource_form_per_unit_hour(inputs)
	if (locale === "hu") return hu_admin_resource_form_per_unit_hour(inputs)
	return ro_admin_resource_form_per_unit_hour(inputs)
});
export { admin_resource_form_per_unit_hour as "admin.resource_form.per_unit_hour" }